import dayjs from 'dayjs';
import { InboundProcess } from '@features/supplyChain/types';
import { getDayDifference } from '@utils';

interface GoodsReceivedNoteSummaryProps {
  selectedInboundProcess: InboundProcess;
  totalReceivedItemsQuantity: number | undefined;
  isDiscrepancy: boolean;
  discrepancyAmount: number;
  isNegativeDiscrepancy: boolean;
}

export function GoodsReceivedNoteSummary({
  selectedInboundProcess,
  totalReceivedItemsQuantity,
  isDiscrepancy,
  discrepancyAmount,
  isNegativeDiscrepancy,
}: GoodsReceivedNoteSummaryProps) {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const { estimatedTimeOfArrival } = selectedInboundProcess.shipmentNote!;
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const { finalisedAt } = selectedInboundProcess.goodsReceivedNote!;

  const deliveryDayDifference = getDayDifference(
    estimatedTimeOfArrival.dateTime as string,
    finalisedAt as string
  );

  const isLate = deliveryDayDifference < 0;

  return (
    <div className='grid grid-cols-2 gap-x-4 gap-y-3'>
      <div>
        <p className='text-sm font-semibold text-gray-900'>
          {selectedInboundProcess?.goodsReceivedNote?.finalisedByName}
        </p>
        <p className='text-xs text-gray-400'>Received by</p>
      </div>
      <div>
        <p className='text-sm font-semibold text-gray-900'>
          {dayjs(selectedInboundProcess?.goodsReceivedNote?.createdAt).format(
            'DD/MM/YY'
          )}
          {isLate && (
            <span className='text-red-600 ml-1'>
              (+{deliveryDayDifference.toString().substring(1)}{' '}
              {deliveryDayDifference.toString().substring(1) === '1'
                ? 'day'
                : 'days'}
              )
            </span>
          )}
        </p>
        <p className='text-xs text-gray-400'>Date of arrival</p>
      </div>
      <div>
        <p className='text-sm font-semibold text-gray-900'>
          {selectedInboundProcess?.goodsReceivedNote?.grnNoteNumber}
        </p>
        <p className='text-xs text-gray-400'>Goods Received Note #</p>
      </div>
      <div>
        <p className='text-sm font-semibold text-gray-900'>
          {selectedInboundProcess?.goodsReceivedNote?.skus.length}
        </p>
        <p className='text-xs text-gray-400'>SKUs</p>
      </div>
      <div>
        <p className='text-sm font-semibold text-gray-900'>
          {totalReceivedItemsQuantity}
          {isDiscrepancy && (
            <span
              className={
                isNegativeDiscrepancy
                  ? 'text-red-600 ml-1'
                  : 'text-gray-900 ml-1'
              }
            >
              ({isNegativeDiscrepancy ? '-' : '+'}
              {Math.abs(discrepancyAmount)})
            </span>
          )}
        </p>
        <p className='text-xs text-gray-400'>Total qty (Items)</p>
      </div>
      {selectedInboundProcess.goodsReceivedNote?.comment && (
        <div className='col-span-2 pt-2'>
          <p className='text-sm text-gray-700'>
            {selectedInboundProcess.goodsReceivedNote.comment}
          </p>
          <p className='text-xs text-gray-400'>Comment</p>
        </div>
      )}
    </div>
  );
}
